// src/hooks/sale/useQuotationHistory.ts

import { useDispatch, useSelector } from 'react-redux';

import useAlerts from '../useAlerts';

import useLoading from '../useLoading';

import useConfirmModal from '../useConfirmModal';

import useApiErrorHandler from '../useApiErrorHandler';

import { AppDispatch, RootState } from '../../store/store';


import {
    setLoading,

    setFilteredQuotationList,

    clearFilteredQuotationList,

    setPageSize,

    setQuotationToView,

    setQuotationLoaded,

    clearQuotationView,

    setOpenQuotationPdfModal,

    setCloseQuotationPdfModal,

    setOpenQuotationViewModal,

    setCloseQuotationViewModal,

    removeQuotationFromList,

    updateQuotationStatus,

} from '../../store/slices/sale/quotationHistorySlice';

import { useQuotation } from './useQuotation';
import QuotationHistoryService from '../../services/sale/QuotationHistoryService';

const useQuotationHistory = () => {

    // =====================================================
    // 🔹 Hooks
    // =====================================================

    const dispatch: AppDispatch = useDispatch();

    const { show: showAlert } = useAlerts();

    const confirm = useConfirmModal();

    const { handle } = useApiErrorHandler();

    const {
        showLoadingIndicator,

        hideLoadingIndicator,

    } = useLoading();

    const {
        cancelActive,
    } = useQuotation();

    // =====================================================
    // 🔹 State
    // =====================================================

    const {

        filteredQuotationList,

        paginator,

        pageSize,

        loading,

        quotationToView,

        quotationLoaded,

        showQuotationPdfModal,

        showQuotationViewModal,

    } = useSelector(
        (state: RootState) =>
            state.quotationHistory
    );

    // =====================================================
    // 🔹 Search
    // =====================================================

    const search = async (
        filters: any,
        page = 0,
        size = pageSize,
        sort = 'quotationDate,desc'
    ) => {

        try {

            showLoadingIndicator();

            dispatch(
                setLoading(true)
            );

            const response =
                await QuotationHistoryService
                    .search(
                        filters,
                        page,
                        size,
                        sort
                    );

            const {
                statusCode,

                data,

            } = response;

            if (statusCode === 200) {

                dispatch(
                    setFilteredQuotationList(
                        data
                    )
                );

            }

        } catch (error) {

            handle(error);

        } finally {

            hideLoadingIndicator();

            dispatch(
                setLoading(false)
            );

        }

    };

    // =====================================================
    // 🔹 View Quotation
    // =====================================================

    // const viewQuotation = async (
    //     quotationId: number
    // ) => {

    //     try {

    //         showLoadingIndicator();

    //         dispatch(
    //             setLoading(true)
    //         );

    //         const response =
    //             await QuotationHistoryService
    //                 .findById(
    //                     quotationId
    //                 );

    //         const {
    //             statusCode,

    //             data,

    //         } = response;

    //         if (statusCode === 200) {

    //             dispatch(
    //                 setQuotationToView(
    //                     data
    //                 )
    //             );

    //             dispatch(
    //                 setQuotationLoaded(
    //                     true
    //                 )
    //             );

    //             dispatch(
    //                 setOpenQuotationViewModal()
    //             );

    //         }

    //     } catch (error) {

    //         handle(error);

    //     } finally {

    //         hideLoadingIndicator();

    //         dispatch(
    //             setLoading(false)
    //         );

    //     }

    // };

    // =====================================================
    // 🔹 Cancel Active
    // =====================================================

    const cancelQuotation = async (
        quotationId: number
    ) => {

        confirm({

            title:
                '¿Cancelar cotización?',

            message:
                'La cotización activa será cancelada y ya no podrá procesarse.',

            icon:
                'warning',

            confirmText:
                'Cancelar',

            cancelText:
                'Cerrar',

            onConfirm: async () => {

                try {

                    await cancelActive(
                        quotationId
                    );

                    dispatch(
                        updateQuotationStatus({
                            id: quotationId,
                            status: 'CANCELLED',
                        })
                    );

                } catch (error) {

                    handle(error);

                }

            },

        });

    };

    // =====================================================
    // 🔹 PDF Modal
    // =====================================================

    const openPdfModal = () => {

        dispatch(
            setOpenQuotationPdfModal()
        );

    };

    const closePdfModal = () => {

        dispatch(
            setCloseQuotationPdfModal()
        );

    };

    // =====================================================
    // 🔹 View Modal
    // =====================================================

    const openViewModal = () => {

        dispatch(
            setOpenQuotationViewModal()
        );

    };

    const closeViewModal = () => {

        dispatch(
            setCloseQuotationViewModal()
        );

        dispatch(
            clearQuotationView()
        );

    };

    // =====================================================
    // 🔹 Helpers
    // =====================================================

    const updatePageSizeHandler = (
        size: number
    ) => {

        dispatch(
            setPageSize(size)
        );

    };

    const clearFilteredList = () => {

        dispatch(
            clearFilteredQuotationList()
        );

    };

    const removeQuotation = (
        quotationId: number
    ) => {

        dispatch(
            removeQuotationFromList(
                quotationId
            )
        );

    };

    // =====================================================
    // ✅ Return
    // =====================================================

    return {

        // =====================================================
        // 🔹 State
        // =====================================================

        filteredQuotationList,

        paginator,

        pageSize,

        loading,

        quotationToView,

        quotationLoaded,

        showQuotationPdfModal,

        showQuotationViewModal,

        // =====================================================
        // 🔹 Actions
        // =====================================================

        search,

        // viewQuotation,

        cancelQuotation,

        updatePageSize:
            updatePageSizeHandler,

        clearFilteredList,

        removeQuotation,

        // =====================================================
        // 🔹 Modals
        // =====================================================

        openPdfModal,

        closePdfModal,

        openViewModal,

        closeViewModal,

    };

};

export default useQuotationHistory;